import { SET_CONVERSATIONS, SET_TOTAL_COUNT } from './types'

const initialState = {
  conversations: [],
  totalCount: 0,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload,
      }
    case SET_TOTAL_COUNT:
      return {
        ...state,
        totalCount: action.payload,
      }
    default:
      return state
  }
}
